import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import classnames from "classnames";
import { Box } from "../Box/index.js";
import { Typography } from "../Typography/index.js";
import { Icon } from "../Icon/index.js";
import { useStyles } from "./MediaEmpty.styles.js";
const MediaEmpty = (t0)=>{
    const $ = c(18);
    const { height: t1, width: t2, variant: t3, radius: t4, testId } = t0;
    const height = void 0 === t1 ? "536px" : t1;
    const width = void 0 === t2 ? "100%" : t2;
    const variant = void 0 === t3 ? "single" : t3;
    const radius = void 0 === t4 ? "s" : t4;
    const { classes } = useStyles();
    const isIconOnly = "iconOnly" === variant;
    const t5 = !isIconOnly && classes.withContent;
    let t6;
    if ($[0] !== classes.root || $[1] !== t5) {
        t6 = classnames(classes.root, t5);
        $[0] = classes.root;
        $[1] = t5;
        $[2] = t6;
    } else t6 = $[2];
    let t7;
    if ($[3] !== classes.icon) {
        t7 = /*#__PURE__*/ jsx(Icon, {
            name: "picture_slash_outline",
            size: "32",
            color: "stroke.secondary",
            className: classes.icon
        });
        $[3] = classes.icon;
        $[4] = t7;
    } else t7 = $[4];
    let t8;
    if ($[5] !== classes.secondaryText || $[6] !== classes.text || $[7] !== isIconOnly || $[8] !== variant) {
        t8 = !isIconOnly && /*#__PURE__*/ jsxs(Box, {
            className: classes.text,
            children: [
                /*#__PURE__*/ jsx(Typography, {
                    variant: "body3",
                    color: "text.light.tertirary",
                    align: "center",
                    children: "multiple" === variant ? "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F." : "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435."
                }),
                /*#__PURE__*/ jsx(Typography, {
                    className: classes.secondaryText,
                    variant: "body3",
                    color: "text.light.tertirary",
                    align: "center",
                    children: "Попробуйте обновить страницу"
                })
            ]
        });
        $[5] = classes.secondaryText;
        $[6] = classes.text;
        $[7] = isIconOnly;
        $[8] = variant;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== height || $[11] !== radius || $[12] !== t6 || $[13] !== t7 || $[14] !== t8 || $[15] !== testId || $[16] !== width) {
        t9 = /*#__PURE__*/ jsxs(Box, {
            className: t6,
            height: height,
            width: width,
            radius: radius,
            testId: testId,
            children: [
                t7,
                t8
            ]
        });
        $[10] = height;
        $[11] = radius;
        $[12] = t6;
        $[13] = t7;
        $[14] = t8;
        $[15] = testId;
        $[16] = width;
        $[17] = t9;
    } else t9 = $[17];
    return t9;
};
export { MediaEmpty };
